import { Engine } from "../engine/engine";
import { initialLocation } from "../engine/pincerjs";
import { designs } from "./designs";

/*
The designed client: the shopfront someone sees when they follow a link, the place new ideas get laid out, and the
app for people who'd rather not go through an assistant. The engine draws the tree; designs.ts says how particular
nodes look, and anything without a design yet is drawn plainly, in place. See docs/design_notes/clients.md.
*/
const engine = new Engine(new pincerjs.PincerApp(), document.getElementById("app")!, {
  designs,
  announce: document.getElementById("announce")!,
});
engine.start(initialLocation());

// Installable, and opens without a connection (sw.ts); not while developing, where it would serve old files
if (PRODUCTION && "serviceWorker" in navigator) {
  navigator.serviceWorker.register("sw.js").catch((problem) => console.log(`No service worker: ${problem}`));
}
